import axios from 'axios';
import S_base from '@/services/wasaapi/__base';

export default {
  async show(idtfId) {
    const res = await axios.get(`act_idtf_assignment/${idtfId}`);
    return res.data.data;
  },
  async fetchData(fetchSetting) {
    const task = [];
    fetchSetting.forEach((item) => {
      if (item.params) {
        task.push(axios.get(item.url, { params: item.params }));
      } else {
        task.push(axios.get(item.url));
      }
    });
    try {
      const modelData = []
      const res = await Promise.all(task);
      res.forEach((item) => {
        modelData.push(item.data.data);
      });
      return modelData
    } catch (error) {
      alert(error);
    }
  },
  async updateCRUDData($event, field, wsCRUDData, key, subModelName) {
    let resultVal = $event[key];
    if (field.type === "hasMany") {
      if ($event[key] === undefined || $event[key] === null) return;
      const res = await axios.get(`/${field.modelName}`);
      resultVal = res.data.data.filter(resData => $event[key].includes(resData.id));
    }
    if (subModelName === 'idtf_check_result' || subModelName === 'idtf_review_result' || subModelName === 'overall_review_result') {
      if (wsCRUDData.last_version !== undefined && wsCRUDData.last_version.act_idtf_assignment_item !== undefined) {
        wsCRUDData.last_version.act_idtf_assignment_item[key] = resultVal;
      }
      if (wsCRUDData.act_idtf_assignment_item !== undefined) {
        wsCRUDData.act_idtf_assignment_item[key] = resultVal;
      }
    } else if (subModelName === 'act_cnt_check_result' ||subModelName === 'act_cnt_review_result') {
      if (wsCRUDData.last_version !== undefined && wsCRUDData.last_version[key] !== undefined) {
        wsCRUDData.last_version[key] = resultVal;
      }
      if (wsCRUDData[key] !== undefined) {
        wsCRUDData[key] = resultVal;
      }
    }
  },
  setTask(updateData, subModelName, fields, modelData, subModelSubmitUrl){
    const task = [];
    for (let key in updateData) {
      if (key !== subModelName) {
        const datas = updateData[key];
        if (datas.length === 0) continue;
        for (let data of datas) {
          if (
            fields[key] !== undefined &&
            fields[key].getSubmitUrl !== undefined
          ) {
            const submitData = fields[key].setSubmitData ? fields[key].setSubmitData(data) : data;
            task.push(axios.patch(
              fields[key].getSubmitUrl(
                {
                  modelData: modelData,
                  updateData: data,
                }
              ),submitData)
            );
          } else {
            continue;
          }
        }
      } else {
        task.push(
          axios.post(subModelSubmitUrl, {
            "act_idtf_assignment_items": updateData[`${subModelName}`],
          })
        );
      }
    }
    return task
  },
  async createIdtfItem(data, idtfId) {
    const _data = {
      act_idtf_assignment : `${idtfId}`,
      ...data,
    };
    const res = await axios.post('act_idtf_assignment_item', _data);
    return res;
  },
  async createIdtfItems(dataList, idtfId) {
    const taskList = [];
    dataList.forEach(data => {
      const _data = {
        act_idtf_assignment : `${idtfId}`,
        ...data,
      }
      taskList.push(axios.post('act_idtf_assignment_item', _data));
    })
    const resList = await Promise.all(taskList);
    const resultDataList = [];
    resList.forEach((res) => {
      resultDataList.push(res.data.data);
    });
    return resultDataList;
  },
  async indexAllIdtfItems(idtfId) {
    let params = {
      page: 1,
    }
    const res = await this.indexIdtfItems(idtfId, params);
    const lastPage = res.meta.last_page;
    if (lastPage > 1) {
      const task = [];
      for (let page = 2; page < lastPage + 1; page ++) {
        params = {
          act_idtf_assignment: idtfId,
          page,
        }
        task.push(axios.get('act_idtf_assignment_item', {params}))
      }
      const resAll = await Promise.all(task);
      const allData = [...res.data];
      resAll.forEach(_res => {
        allData.push(..._res.data.data);
      })
      return allData;
    } else {
      return res.data;
    }
  },
  async indexIdtfItems(idtfId, params) {
    const _params = {
      act_idtf_assignment: idtfId,
      ...params
    };
    const res = await axios.get('act_idtf_assignment_item', {params: _params});
    return res.data;
  },
  async getRelatedTempNum(rawData) {
    const preActVersionId = rawData.act_version.id;
    const templateList = [
      'license_template',
      'internal_training_template',
      'checklist_template',
      'audit_template',
      'contractor_license_template',
    ];
    const task = templateList.map(temp => axios.get(`${temp}/act_version/${preActVersionId}`));
    const resAll = await Promise.all(task);
    let total = 0;
    resAll.forEach(res => {
      total += res.data.meta.total;
    })
    return total;
  },
  async startIdentify(assignmentId) {
    await axios.post(`act_idtf_assignment/${assignmentId}/start/indentify`);
  },
  async create(data) {
    const res = await S_base.create({
      url: 'v2/act_idtf_assignment/create',
      data,
    });
    return res;
  },
  async update(idtfId, data) {
    const res = await S_base.update({
      modelName: 'act_idtf_assignment',
      modelId: idtfId,
      payload: data,
    });
    return res;
  },
  async updateIdtfItem(idtfItemId, payload) {
    const res = await S_base.update({
      modelName: 'act_idtf_assignment_item',
      modelId: idtfItemId,
      payload,
    });
    return res;
  },
  async createCommentIdtfAssignment(data) {
    const res = await S_base.create({
      url: 'act_idtf_assignment/comment/create',
      data,
    });
    return res;
  },
};
